<template>
    <div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.EmployeeNumber}">
                Employee#: <i class="fa fa-asterisk text-danger"></i>
            </label>
            <div class="col-sm-8">
                <input type="text" name="EmployeeNumber" v-model="employee.EmployeeNumber" :class="{'form-control': true, 'is-invalid': errors.EmployeeNumber}" placeholder="Enter Employee Number" />

                <div v-if="!employee.EmployeeId && total_employees !== null" class="mt-1 mb-1">
                    <b-form-checkbox v-model="use_suggested" :value="true" :unchecked-value="false" plain>
                        <i class="fa fa-question-circle text-muted" :title="`Incremental number based on total employee records: ${total_employees}`"></i>
                        <span class="text-muted">Use Suggested Employee#:</span>&nbsp;
                        <span>{{ suggestedEmployeeNumber }}</span>
                    </b-form-checkbox>
                </div>

                <span v-if="errors.EmployeeNumber" class="text-danger">
                    <span v-for="error in errors.EmployeeNumber">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.FirstName}">First Name:  <i class="fa fa-asterisk text-danger"></i></label>
            <div class="col-sm-8">
                <input type="text" name="FirstName" v-model="employee.FirstName" :class="{'form-control': true, 'is-invalid': errors.FirstName}" placeholder="Enter First Name (Required)" />
                <span v-if="errors.FirstName" class="text-danger">
                    <span v-for="error in errors.FirstName">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.LastName}">Last Name:  <i class="fa fa-asterisk text-danger"></i></label>
            <div class="col-sm-8">
                <input type="text" name="LastName" v-model="employee.LastName" :class="{'form-control': true, 'is-invalid': errors.LastName}" placeholder="Enter Last Name (Required)" />
                <span v-if="errors.LastName" class="text-danger">
                    <span v-for="error in errors.LastName">{{ error }}</span>
                </span>
            </div>
        </div>
        <hr/>

        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.subcontractor_id}">Subcontractor:</label>
            <div class="col-sm-8">
                <subcontractor-select ref="empSubSelect" :selectedValues="SubcontractorValues" @vselected="onSubSelectUpdate" :hasError="errors.subcontractor_id ? true : false"></subcontractor-select>

                <div v-if="errors.subcontractor_id" class="text-danger">
                    <span v-for="error in errors.subcontractor_id">{{ error }}</span>
                </div>

                <template  v-if="this.$root.hasPermission('subcontractors.manage')">
                    <div class="mt-2">
                        <subcontractor-modal :showButton="showCreateSubcontractor" @subcontractorCreated="subcontractorCreated" />
                    </div>
                </template>
            </div>
        </div>
        <div class="row form-group mb-4" v-if="employee.subcontractor_id">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.tiered_sub_name}">Tiered Subcontractor:</label>
            <div class="col-sm-8">
                <input type="text" name="tiered_sub_name" v-model="employee.tiered_sub_name" :class="{'form-control': true, 'is-invalid': errors.tiered_sub_name}" placeholder="Enter Tiered Subcontractor Name" />

                <span v-if="errors.tiered_sub_name" class="text-danger">
                    <span v-for="error in errors.tiered_sub_name">{{ error }}</span>
                </span>
            </div>
        </div>
        <hr/>

        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.middle_name}">Middle Name:</label>
            <div class="col-sm-8">
                <input type="text" name="middle_name" v-model="employee.middle_name" :class="{'form-control': true, 'is-invalid': errors.middle_name}" placeholder="Enter Middle Name or Initial" />
                <span v-if="errors.middle_name" class="text-danger">
                    <span v-for="error in errors.middle_name">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.gender}">Gender:</label>
            <div class="col-sm-8">
                <b-form-select v-model="employee.gender" :options="genderOptions" :class="{'is-invalid': errors.gender}" />

                <span v-if="errors.gender" class="text-danger">
                    <span v-for="error in errors.gender">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.suffix}">Suffix:</label>
            <div class="col-sm-8">
                <input type="text" name="suffix" v-model="employee.suffix" :class="{'form-control': true, 'is-invalid': errors.suffix}" placeholder="Ex: Sr." />
                <span v-if="errors.suffix" class="text-danger">
                    <span v-for="error in errors.suffix">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.Phone}">
                Phone Number: <i class="fa fa-asterisk text-danger" v-if="isRequired('Phone')"></i>
            </label>
            <div class="col-sm-8">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-light">+1</span>
                    </div>
                    <input type="text" name="Phone" v-model="employee.Phone" :class="{'form-control': true, 'is-invalid': errors.Phone}" placeholder="Enter Phone" />
                </div>
                <span v-if="errors.Phone" class="text-danger">
                    <span v-for="error in errors.Phone">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4" v-if="employee.Phone">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.Phone}">
                Enable Receiving Text Blasts
            </label>
            <div class="col-sm-8">
                <b-form-checkbox v-model="employee.enable_text_blasts" :value="1" :unchecked-value="0" plain>
                    <span>Check this box to enable Safety Meeting & Training Course text blasts.</span>
                </b-form-checkbox>

                <div class="alert alert-warning mb-1 mt-1">
                    By checking this box, you are confirming that you have received verbal and/or written consent from the employee to send MeritEHS messages to their phone number.
                </div>

                <span v-if="errors.Phone" class="text-danger">
                    <span v-for="error in errors.Phone">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.email}">
                Email: <i class="fa fa-asterisk text-danger" v-if="isRequired('email')"></i>
            </label>
            <div class="col-sm-8">
                <input type="text" name="email" v-model="employee.email" :class="{'form-control': true, 'is-invalid': errors.email}" placeholder="Enter Email" />
                <span v-if="errors.email" class="text-danger">
                    <span v-for="error in errors.email">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.position}">
                Position: <i class="fa fa-asterisk text-danger" v-if="isRequired('position')"></i>
            </label>
            <div class="col-sm-8">
                <input type="text" name="position" v-model="employee.position" :class="{'form-control': true, 'is-invalid': errors.position}" placeholder="Enter Position" />
                <span v-if="errors.position" class="text-danger">
                    <span v-for="error in errors.position">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.division_id}">
                Primary Division: <i class="fa fa-asterisk text-danger" v-if="isRequired('division_id')"></i>
            </label>
            <div class="col-sm-8">
                <b-form-select v-model="employee.division_id" :options="divisionOptions" :class="{'is-invalid': errors.division_id}"></b-form-select>

                <div v-if="errors.division_id" class="text-danger">
                    <span v-for="error in errors.division_id">{{ error }}</span>
                </div>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.other_division_ids}">Other Divisions:</label>
            <div class="col-sm-8">
                <b-form-select v-model="other_division_id" :options="otherDivisionOptions" :class="{'is-invalid': errors.other_division_ids}" v-on:change="addOtherDivision"></b-form-select>

                <div class="mt-2">
                    <div v-for="division_id in other_division_ids" class="mb-2">
                        <button class="btn btn-xs btn-default" v-on:click="removeOtherDivision(division_id)"><i class="fa fa-trash text-danger"></i></button> {{ getDivisionName(division_id) }} </div>
                </div>

                <div v-if="errors.other_division_ids" class="text-danger">
                    <span v-for="error in errors.other_division_ids">{{ error }}</span>
                </div>
            </div>
        </div>
        <hr/>

        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.current_jobsite_id}">Current Jobsite:</label>
            <div class="col-sm-8">
                <jobsite-select ref="empCurrentJobsiteSelect" :selectedValues="JobsiteValues" @vselected="onJobSiteSelectUpdate" :hasError="errors.current_jobsite_id ? true : false"></jobsite-select>

                <div v-if="errors.current_jobsite_id" class="text-danger">
                    <span v-for="error in errors.current_jobsite_id">{{ error }}</span>
                </div>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.current_jobsite_id}">All Assigned Jobsites:</label>
            <div class="col-sm-8">
                <jobsite-select ref="empAssignedJobsiteSelect" @vselected="addAssignedJobsite"></jobsite-select>

                <div class="mt-2" v-if="employee.jobsites">
                    <div class="mb-1" v-for="jobsite in employee.jobsites">
                        <button class="btn btn-xs btn-default" v-on:click="removeEmpJobsite(jobsite.JobsiteId)" title="Remove Assigned Jobsite">
                            <i class="fa fa-trash text-danger"></i>
                        </button>
                        <span v-if="jobsite.JobsiteNumber">{{ jobsite.JobsiteNumber }} - </span>{{ jobsite.JobsiteName }}
                    </div>
                </div>
            </div>
        </div>

        <hr/>

        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.trade}">
                Trade: <i class="fa fa-asterisk text-danger" v-if="isRequired('trade')"></i>
            </label>
            <div class="col-sm-8">
                <input type="text" name="trade" v-model="employee.trade" :class="{'form-control': true, 'is-invalid': errors.trade}" placeholder="Enter Trade" />
                <span v-if="errors.trade" class="text-danger">
                    <span v-for="error in errors.trade">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.IsActive}">Active:</label>
            <div class="col-sm-8">
                <b-form-checkbox v-model="employee.IsActive" :value="1" :unchecked-value="0" plain></b-form-checkbox>
                <span v-if="errors.IsActive" class="text-danger">
                    <span v-for="error in errors.IsActive">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.is_temp_employee}">Is Temp Employee:</label>
            <div class="col-sm-8">
                <b-form-checkbox v-model="employee.is_temp_employee" :value="1" :unchecked-value="0" plain></b-form-checkbox>
                <span v-if="errors.is_temp_employee" class="text-danger">
                    <span v-for="error in errors.is_temp_employee">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.driver_status_id}">Approved Driver:</label>
            <div class="col-sm-8">
                <b-form-select v-model="employee.driver_status_id" :options="driverOptions"></b-form-select>
                <span v-if="errors.driver_status_id" class="text-danger">
                    <span v-for="error in errors.driver_status_id">{{ error }}</span>
                </span>
            </div>
        </div>

        <hr/>

        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.Address}">
                Address: <i class="fa fa-asterisk text-danger" v-if="isRequired('Address')"></i>
            </label>
            <div class="col-sm-8">
                <input type="text" name="Address" v-model="employee.Address" :class="{'form-control': true, 'is-invalid': errors.Address}" placeholder="Enter Address" />
                <span v-if="errors.Address" class="text-danger">
                    <span v-for="error in errors.Address">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.City}">
                City: <i class="fa fa-asterisk text-danger" v-if="isRequired('City')"></i>
            </label>
            <div class="col-sm-8">
                <input type="text" name="City" v-model="employee.City" :class="{'form-control': true, 'is-invalid': errors.City}" placeholder="Enter City" />
                <span v-if="errors.City" class="text-danger">
                    <span v-for="error in errors.City">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.State}">
                State: <i class="fa fa-asterisk text-danger" v-if="isRequired('State')"></i>
            </label>
            <div class="col-sm-8">
                <input type="text" name="State" v-model="employee.State" :class="{'form-control': true, 'is-invalid': errors.State}" placeholder="Ex: NC" />
                <span v-if="errors.State" class="text-danger">
                    <span v-for="error in errors.State">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.Zip}">
                Zip: <i class="fa fa-asterisk text-danger" v-if="isRequired('Zip')"></i>
            </label>
            <div class="col-sm-8">
                <input type="text" name="Zip" v-model="employee.Zip" :class="{'form-control': true, 'is-invalid': errors.Zip}" placeholder="Enter Zip" />
                <span v-if="errors.Zip" class="text-danger">
                    <span v-for="error in errors.Zip">{{ error }}</span>
                </span>
            </div>
        </div>

        <hr/>

        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.ssn_last_4}">
                SSN Last 4: <i class="fa fa-asterisk text-danger" v-if="isRequired('ssn_last_4')"></i>
            </label>
            <div class="col-sm-8">
                <input type="text" name="ssn_last_4" v-model="employee.ssn_last_4" :class="{'form-control': true, 'is-invalid': errors.ssn_last_4}" placeholder="Enter Last 4 of SSN " />
                <span v-if="errors.ssn_last_4" class="text-danger">
                    <span v-for="error in errors.ssn_last_4">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.BirthDate}">
                Birth Date: <i class="fa fa-asterisk text-danger" v-if="isRequired('BirthDate')"></i>
            </label>
            <div class="col-sm-8">
                <input type="date" name="BirthDate" v-model="employee.BirthDate" :class="{'form-control': true, 'is-invalid': errors.BirthDate}" placeholder="Enter Birth Date" />
                <span v-if="errors.BirthDate" class="text-danger">
                    <span v-for="error in errors.BirthDate">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.HireDate}">
                Hire Date: <i class="fa fa-asterisk text-danger" v-if="isRequired('HireDate')"></i>
            </label>
            <div class="col-sm-8">
                <input type="date" name="HireDate" v-model="employee.HireDate" :class="{'form-control': true, 'is-invalid': errors.HireDate}" placeholder="Enter Hire Date" />

                <span v-if="errors.HireDate" class="text-danger">
                    <span v-for="error in errors.HireDate">{{ error }}</span>
                </span>
            </div>
        </div>
        <div v-bind:class="{ 'form-group': true, 'has-error': errors.last_rehire_date }" class="row">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.last_rehire_date}">
                Last Rehire Date: <i class="fa fa-asterisk text-danger" v-if="isRequired('last_rehire_date')"></i>
            </label>
            <div class="col-sm-8">
                <input type="date" name="last_rehire_date" v-model="employee.last_rehire_date" :class="{'form-control': true, 'is-invalid': errors.last_rehire_date}" placeholder="Enter Last Rehire Date" />
                <span v-if="errors.last_rehire_date" class="text-danger">
                    <span v-for="error in errors.last_rehire_date">{{ error }}</span>
                </span>
            </div>
        </div>
        <div class="row form-group mb-4">
            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.WeeklySalary}">
                Weekly Salary: <i class="fa fa-asterisk text-danger" v-if="isRequired('WeeklySalary')"></i>
            </label>
            <div class="col-sm-8">
                <input type="text" name="WeeklySalary" v-model="employee.WeeklySalary" :class="{'form-control': true, 'is-invalid': errors.WeeklySalary}" placeholder="Enter Weekly Salary" />
                <span v-if="errors.WeeklySalary" class="text-danger">
                    <span v-for="error in errors.WeeklySalary">{{ error }}</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            employee: {
                type: Object,
                default: {
                    division_id: null,
                    subcontractor_id: null,
                }
            },

            divisions: {
                type: Array,
                default: []
            },

            drivers: {
                type: Array,
                default: []
            },

            required_fields: {
                type: Array,
                default: []
            },

            showCreateSubcontractor: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                errors: {},
                use_suggested: false,
                total_employees: null,
                other_division_id: null,
                other_division_ids: [],
            }
        },

        watch: {
            use_suggested(newVal, oldVal){
                //Check for True
                if(newVal === true)
                {
                    //Set it
                    this.setSuggestedEmpNum();
                }
            },

            'employee.subcontractor_id'(newVal, oldVal){
                //Clear the Tiered Sub Name
                if(newVal == null)
                {
                    this.employee.tiered_sub_name = null;
                }
            }
        },

        computed: {
            //Build it
            divisionOptions(){
                //Setup options
                var options = [
                    {value: null, text: '-- Select a Division--'},
                ];

                //Loop through and build lists
                for(var i = 0; i < this.divisions.length; i++)
                {
                    //Push onto options
                    options.push({value: this.divisions[i].DivisionId, text: (this.divisions[i].division_code+ ' - '+this.divisions[i].DivisionName)});
                }

                //Send it
                return options;
            },

            genderOptions(){
                //Setup options
                var options = [
                    {value: null, text: '-- Select Gender --'},
                    {value: 'Male', text: 'Male'},
                    {value: 'Female', text: 'Female'},
                ];

                //Send it
                return options;
            },

            //Build it
            otherDivisionOptions(){
                //Setup options
                var options = [
                    {value: null, text: '-- Select Other Divisions--'},
                ];

                //Loop through and build lists
                for(var i = 0; i < this.divisions.length; i++)
                {
                    //Make sure not already selected
                    if(this.divisions[i].DivisionId == this.employee.division_id)
                    {
                        continue;
                    }

                    //If Already Selected in the Other
                    if(this.other_division_ids.indexOf(this.divisions[i].DivisionId) !== -1)
                    {
                        continue;
                    }

                    //Push onto options
                    options.push({value: this.divisions[i].DivisionId, text: (this.divisions[i].division_code+ ' - '+this.divisions[i].DivisionName)});
                }

                //Send it
                return options;
            },

            driverOptions(){
                var options = [
                    {value: null, text: '-- Select Approved Driver or Leave Blank --'},
                ];

                for(var i = 0; i < this.drivers.length; i++)
                {
                    //Push
                    options.push({value: this.drivers[i].id, text: this.drivers[i].driver_status_name});
                }

                //Send iot
                return options;
            },

            SubcontractorValues(){
                //check for null
                if(!this.employee || !this.employee.subcontractor_id || this.employee.subcontractor_id == null)
                {
                    //Send it
                    return null;
                }

                //Send it
                return {subcontractor_id: this.employee.subcontractor_id, subcontractor_name: this.employee.subcontractor_name};
            },

            JobsiteValues(){
                //check for null
                if(!this.employee.current_jobsite_id || this.employee.current_jobsite_id == null)
                {
                    //Send it
                    return null;
                }

                //Send it
                return {JobsiteId: this.employee.current_jobsite_id, JobsiteNumber: this.employee.JobsiteNumber, JobsiteName: this.employee.JobsiteName};
            },

            suggestedEmployeeNumber(){
                //Check for subcontractor
                if(this.total_employees === null)
                {
                    return '';
                }

                //Build the Value
                var num = this.total_employees + 1 + '';

                //Process the LENGTH
                for(var i = num.length; i < 5; i++)
                {
                    //Prepend
                    num = '0' + num;
                }

                //Check for Temp
                if(this.employee.is_temp_employee == 1)
                {
                    num = 'T' + num;
                }

                //Check for Sub?
                if(this.employee.subcontractor_id)
                {
                    num = 'S' + num;
                }

                //Send it
                return num;
            }
        },

        methods: {
            //Get the Various Resources We Need to Edit an Employee
            getErrorClass(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },

            getSuggestedValues(){
                //Get the data
                this.$http
                    .get('employees/suggested')
                    .then(response => {
                        //Set all the data
                        this.total_employees = response.data.total_employees;
                    })
                    .catch(response => {

                    });
            },

            saveEmployee(extraData = null, files = {}) {
                //Reset the errors
                this.errors = {};

                //Loop and Build
                if(extraData)
                {
                    //Loop and Build
                    var keys = Object.keys(extraData);

                    //Loop
                    for (var i = keys.length - 1; i >= 0; i--)
                    {
                        //Append to employee
                        this.employee[keys[i]] = extraData[keys[i]];
                    }
                }

                //Send it
                this.$http
                .postWithFiles('employees/edit' + (this.employee.EmployeeId ? '/' + this.employee.EmployeeId : ''), this.employee, files)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Employee Saved');

                    //Emit
                    this.$emit('employeeSaved', response.data);

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data

                        //Alert the errors
                        this.$emit('employeeFormErrors', this.errors);
                    }

                    //Send it
                    this.$emit('employeeFailed', null);
                })
            },

            onJobSiteSelectUpdate (jobsite) {
                //Check for null
                if(jobsite == null)
                {
                    //Set this to an empty string. Setting it = null omits the param
                    //from being passed through to the back end so the value cannot
                    //be cleared out
                    this.employee.current_jobsite_id = '';

                    //Stop Here
                    return;
                }

                //Send the value
                this.employee.current_jobsite_id = jobsite.JobsiteId;
            },

            addAssignedJobsite(jobsite){
                //Check for null
                if(!jobsite || !jobsite.JobsiteName)
                {
                    return;
                }

                //Build onto the stack
                if(!this.employee.jobsites || Array.isArray(this.employee.jobsites))
                {
                    //Instantiatet he Object
                    this.employee.jobsites = {};
                }

                //Push
                this.employee.jobsites[jobsite.JobsiteId] = jobsite;

                //Force update?
                this.$forceUpdate();

                //Reset the jobsites
                this.$refs.empAssignedJobsiteSelect.clearInput();
            },

            removeEmpJobsite(jobsite_id){
                //Splice
                delete this.employee.jobsites[jobsite_id];

                this.$forceUpdate();
            },

            onSubSelectUpdate(sub) {
                //Check for null
                if(sub == null)
                {
                    //Clear the value
                    this.employee.subcontractor_id = '';

                    //Update the Suggested Number
                    this.setSuggestedEmpNum();

                    //Stop Here
                    return;
                }

                //Send the value
                this.employee.subcontractor_id = sub.subcontractor_id;

                //Update the Suggested Number
                this.setSuggestedEmpNum();
            },

            setSuggestedEmpNum(){
                //IF the value is not set to true, do nothing
                if(!this.use_suggested)
                {
                    return;
                }

                //Set it
                this.employee.EmployeeNumber = this.suggestedEmployeeNumber;
            },

            getDivisionName(division_id){
                //Loop through and build lists
                for(var i = 0; i < this.divisions.length; i++)
                {
                    //Make sure not already selected
                    if(this.divisions[i].DivisionId == division_id)
                    {
                        return (this.divisions[i].division_code ? this.divisions[i].division_code+' - ' : '') + this.divisions[i].DivisionName;
                    }
                }

                //Send empty
                return '';
            },

            addOtherDivision(data){
                //Push
                this.other_division_ids.push(data);

                //REset
                this.other_division_id = null;

                //Set on the employee?
                this.employee.other_division_ids = this.other_division_ids;
            },

            removeOtherDivision(division_id){
                //Loop through and build lists
                for(var i = 0; i < this.other_division_ids.length; i++)
                {
                    //Make sure not already selected
                    if(this.other_division_ids[i] == division_id)
                    {
                        //Remove it
                        this.other_division_ids.splice(i, 1);
                    }
                }

                //Set on the employee?
                this.employee.other_division_ids = this.other_division_ids;
            },

            subcontractorCreated(subcontractor){
                //Set the values
                this.employee.subcontractor_id = subcontractor.subcontractor_id;

                //Set the name
                this.employee.subcontractor_name = subcontractor.subcontractor_name;
            },

            isRequired(attr){
                //Check it
                return this.required_fields.indexOf(attr) !== -1 ? true : false;
            },
        },

        mounted() {
            //Check the prop
            if(!this.employee.division_id)
            {
                this.employee.division_id = null;
            }

            //Set the other_division_ids
            if(this.employee.other_divisions && this.employee.other_divisions.length > 0)
            {
                //Build the IDs
                var ids = [];

                //Loop and Set
                for (var i = 0; i < this.employee.other_divisions.length; i++)
                {
                    //Push
                    ids.push(this.employee.other_divisions[i].DivisionId);
                }

                //Set it
                this.other_division_ids = ids;
            }

            //Check for an ID
            if(!this.employee.EmployeeId)
            {
                //Get the total
                this.getSuggestedValues();
            }
        }
    }
</script>
